import { render } from "./AddDirectoryServers.vue?vue&type=template&id=be1d56a2&ts=true"
import script from "./AddDirectoryServers.vue?vue&type=script&lang=ts"
export * from "./AddDirectoryServers.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__